var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { DeviceDetect } from "sb-resp-utils";
import * as EvHandlers from "../EventHandlers";
import { observable, action } from "mobx";
var PopupController = /** @class */ (function () {
    function PopupController(config) {
        var _this = this;
        this.repositionPopup = function () {
            _this.setIsInIframe(false);
            EvHandlers.setContentTopPosition.call(_this);
        };
        this.config = config;
        this.eventHandlers = EvHandlers;
        this.deviceDetect = DeviceDetect.getInstance();
        this.contentElTop = [this.config.offsetTop ? this.config.offsetTop + "px" : "auto"];
        this.isInIframe = (typeof this.config.isInIframe !== "undefined") ? this.config.isInIframe : this.getIsInIframe();
        this.setContentTopPositionRef = EvHandlers.setContentTopPositionDebounced.bind(this);
        this.shouldShow = false;
        this.setClassName = "";
        this.setIsInIframe = this.setIsInIframe.bind(this);
        internalMessageBus.emit(InternalMessageBusChannels.legacy.application.seamless.isIframeHeightControlled, { callback: this.repositionPopup });
    }
    PopupController.prototype.manageContentElClass = function (className) {
        this.setClassName = className;
    };
    PopupController.prototype.show = function () {
        this.execute(this.config.beforeShowCallback);
        this.setVisibility(true);
        EvHandlers.desktopScrollHandling.setScrollVals();
        this.attachEventHandlers();
        EvHandlers.setContentTopPosition.call(this);
        setTimeout(this.execute.bind(this, this.config.afterShowCallback), 0);
        if (this.config.isInIframe) {
            this.manageContentElClass("rj-popup-message__isInIframe");
        }
        else if (typeof this.config.offsetTop !== "undefined") {
            this.manageContentElClass("rj-popup-message__hasOffSet");
        }
        else {
            this.manageContentElClass("rj-popup-message__wrapper");
        }
    };
    PopupController.prototype.hide = function () {
        this.execute(this.config.beforeHideCallback);
        this.detachEventHandlers();
        this.setVisibility(false);
        this.manageContentElClass("");
        setTimeout(this.execute.bind(this, this.config.afterHideCallback), 0);
        this.execute(this.config.legacyCallback);
    };
    PopupController.prototype.setContentElTop = function (offsetTop) {
        this.contentElTop = [offsetTop ? offsetTop + "px" : "auto"];
    };
    PopupController.prototype.setVisibility = function (visible) {
        this.shouldShow = visible;
    };
    PopupController.prototype.attachEventHandlers = function () {
        window.addEventListener("scroll", EvHandlers.desktopScrollHandling.handler);
        //debounce this:
        window.addEventListener("resize", this.setContentTopPositionRef);
    };
    PopupController.prototype.detachEventHandlers = function () {
        window.removeEventListener("scroll", EvHandlers.desktopScrollHandling.handler);
        window.removeEventListener("resize", this.setContentTopPositionRef);
    };
    PopupController.prototype.execute = function (fn) {
        typeof fn === "function" && fn(this);
    };
    PopupController.prototype.getIsInIframe = function () {
        return window.self !== window.top;
    };
    PopupController.prototype.setIsInIframe = function (value) {
        this.isInIframe = value;
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PopupController.prototype, "contentElTop", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], PopupController.prototype, "shouldShow", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PopupController.prototype, "setContentElTop", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PopupController.prototype, "setVisibility", null);
    return PopupController;
}());
export { PopupController };
//# sourceMappingURL=PopupController.js.map